<template>
  <div class="content-page">
    <page-title>Demo page</page-title>
    <section-block :headerOverflowHidden="true">
      <template slot="actions">
        <base-button primary="true" @click="goBack"
          >Go back to editor</base-button
        >
      </template>
      <hero-slider-multi :slider="preview" display />
    </section-block>
  </div>
</template>

<script>
import HeroSliderMulti from "@/components/HeroSliderMulti.vue";
export default {
  name: "AdminBannerPreview",
  data() {
    return {
      preview: null,
    };
  },
  mounted() {
    this.preview = this.$store.state.Banner.preview;
    // need to update durations
    this.preview.banners.forEach((banner) => {
      banner.durations = banner.duration * 1000;
    });
  },
  components: { HeroSliderMulti },
  methods: {
    goBack() {
      this.$router.push({
        name: "AdminBannerEdit",
        params: { id: this.preview.id },
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
